import mondaySdk from 'monday-sdk-js'
import axios from 'axios'
import JsonURL from 'json-url'
class Monday {
  constructor () {
    this.app = null
  }

  // check if your application is inside Monday context
  getMondayContext = async (urlParams) => {
    console.log('getMondayContext()')
    try {
      // init mondaySDK
      this.app.monday.sdk = mondaySdk()
      this.app.mondayContext = await this.app.monday.sdk.get('context')
      // call sdk api with graphgl query to get information about current user, id, email, location(current view), account and slug(slug is subdomain)
      const slug = await this.app.monday.sdk.api('query { me { id, email, location, account { slug } } }')
      console.log('SLUG', slug, 'CONTEXT', this.app.mondayContext)
      // if mondayContext.data exist that means that you webclient application is loaded inside monday
      if (this.app.mondayContext.data !== undefined) {
        this.app.isMonday = true
        // call your service to check and get token for current user
        const tokenResponse = await axios.post('https://mobilescan.solumainvoicereader.com:3040/api/auth/monday/token/' + this.app.mondayContext.data.user.id + '/' + slug.data.me.account.slug)
        console.log('toeknResponse', tokenResponse)
        // if token exist go on and work something with token
        if (tokenResponse.data.data !== null) {
          console.log('token exist')
          this.app.mondayContext.token = tokenResponse.data.data
          console.log('access token', this.app.mondayContext.token.access_token)
          this.app.monday.sdk.setToken(this.app.mondayContext.token.access_token)
          const mondayAnalyticsData = {
            userId: slug.data.me.id,
            email: slug.data.me.email,
            accountId: slug.account_id,
            slug: slug.data.me.account.slug
          }
          this.app.$swsa.setMonday(mondayAnalyticsData)
          if (this.app.mondayContext.data.itemId !== undefined && this.app.mondayContext.data.itemId !== null && this.app.mondayContext.data.itemId !== '') {
            this.app.monday.item.id = this.app.mondayContext.data.itemId
            this.app.mondayContext.data.itemId = parseInt(this.app.mondayContext.data.itemId)
          }
        } else {
          // if token does not exist make request for token
          console.log('need authentication and token request')
          const jc = JsonURL('lzma')
          const state = { context: this.app.mondayContext, slug: slug }
          const stateOutput = await jc.compress(state)
          const url = 'https://auth.monday.com/oauth2/authorize?client_id=797b7177c8bd82d1360d44aac76cf76a&state=' + stateOutput + '&subdomain=' + slug.data.me.account.slug
          window.open(url, '_self')
        }
      } else {
        this.app.isMonday = false
        this.app.mondayContext = null
      }
    } catch (err) {
      this.app.isMonday = false
      this.app.mondayContext = null
      console.log('MONDAY CONTEXT ERROR:', err)
    }
  }
}
const object = new Monday()
export default object
